import { AllTokens } from "gql/graphql";
import { ReactNode } from "react";
import { Guard } from "@/shared/security/model/guard/guard";
import { useHasAnyAccess } from "@/shared/security/model/use-has-any-access";
import { ToPageNotFound } from "@/shared/redirects/to-page-not-found";

/**
 * Вакансии и всё, что к ним привязано: свои и чужие вакансии, отклики на них.
 * «Вакансии» и «Мои вакансии» закрыты одним правом — см. комментарий в menu.tsx.
 *
 * Право контекстное, а страница открывается до всякой записи: уровень спросить не у кого.
 * Вход даёт сам факт доступа хоть к чьим-то вакансиям; что можно менять в конкретной,
 * решает уже она — по своим правам напротив записи.
 */
export function RestrictVacancies({ children }: { children: ReactNode }) {
  const hasAccess = useHasAnyAccess(AllTokens.RecruitingVacancies);

  if (!hasAccess) {
    return <ToPageNotFound />;
  }

  return children;
}

/** Кандидаты: список и карточка. */
export function RestrictCandidates({ children }: { children: ReactNode }) {
  return (
    <Guard.Redirect.IfCantModify.PageNotFound
      influencedBy={[AllTokens.RecruitingCandidates]}
    >
      {children}
    </Guard.Redirect.IfCantModify.PageNotFound>
  );
}

/** Интервью: список и карточка. */
export function RestrictInterviews({ children }: { children: ReactNode }) {
  return (
    <Guard.Redirect.IfCantModify.PageNotFound
      influencedBy={[AllTokens.RecruitingInterviews]}
    >
      {children}
    </Guard.Redirect.IfCantModify.PageNotFound>
  );
}

/** Реестр Job Offer. Карточку токеном не закрываем: участник документа открывает её из КЭДО. */
export function RestrictJobOffers({ children }: { children: ReactNode }) {
  const hasAccess = useHasAnyAccess(AllTokens.RecruitingJobOffers);

  if (!hasAccess) {
    return <ToPageNotFound />;
  }

  return children;
}
